import { BFFGateway, LeaguesResponse, LeaguesByLeagueIdRequest } from "sb-resp-lib";
import { LeaguesRetriever, DataProvider } from "../../Typings";

export class CouponLeaguesRetriever implements LeaguesRetriever {
    private bff: BFFGateway;
    private dataProvider: DataProvider;
    requestCouponLeagues: LeaguesByLeagueIdRequest;
    private loadedData: Function;

    constructor(bffGateway: BFFGateway, dataProvider: DataProvider, loadedData: Function) {
        this.bff = bffGateway;
        this.dataProvider = dataProvider;
        this.loadedData = loadedData;

        this.requestCouponLeagues = {};
        this.requestCouponLeagues.ids = this.dataProvider.leagueIds;
    }

    /* istanbul ignore next */
    setRegionIds(regionId: string) {
        // Not implemented
    }

    /* istanbul ignore next */
    removeRegionId() {
        // Not implemented
    }

    loadData() {
        this.bff.getLeaguesByLeagueId(this.requestCouponLeagues)
            .then(response => this.loadDataSuccessCb(response))
            .catch(err => { console["log"](err) });
    }

    private loadDataSuccessCb(response: LeaguesResponse): void {
        if (response.leagues && response.leagues.length) {
            this.loadedData(response.leagues);
        }
    }
}